/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Align_Left_Left_Justify_Left_PosInputs */

const en_align_left_left_justify_left_pos = /** @type {(inputs: Align_Left_Left_Justify_Left_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Left Justify / Left Position`)
};

const fr_align_left_left_justify_left_pos = /** @type {(inputs: Align_Left_Left_Justify_Left_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Justification Gauche / Position Gauche`)
};

const de_align_left_left_justify_left_pos = /** @type {(inputs: Align_Left_Left_Justify_Left_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linksbündig / Linksposition`)
};

const it_align_left_left_justify_left_pos = /** @type {(inputs: Align_Left_Left_Justify_Left_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giustifica a sinistra / Posizione a sinistra`)
};

const ru_align_left_left_justify_left_pos = /** @type {(inputs: Align_Left_Left_Justify_Left_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выравнивание по левому краю / Позиция по левому краю`)
};

const es_align_left_left_justify_left_pos = /** @type {(inputs: Align_Left_Left_Justify_Left_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Justificar a la izquierda / Posición izquierda`)
};

const zh_cn2_align_left_left_justify_left_pos = /** @type {(inputs: Align_Left_Left_Justify_Left_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`左对齐 / 左对齐`)
};

const ja_align_left_left_justify_left_pos = /** @type {(inputs: Align_Left_Left_Justify_Left_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`左揃え / 左配置`)
};

const hi_align_left_left_justify_left_pos = /** @type {(inputs: Align_Left_Left_Justify_Left_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बाएँ संरेखित करें / बाएँ स्थिति`)
};

const pt_pt2_align_left_left_justify_left_pos = /** @type {(inputs: Align_Left_Left_Justify_Left_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Justificar à esquerda / Posicionamento à esquerda`)
};

/**
* | output |
* | --- |
* | "Left Justify / Left Position" |
*
* @param {Align_Left_Left_Justify_Left_PosInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const align_left_left_justify_left_pos = /** @type {((inputs?: Align_Left_Left_Justify_Left_PosInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Align_Left_Left_Justify_Left_PosInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_align_left_left_justify_left_pos(inputs)
	if (locale === "de") return de_align_left_left_justify_left_pos(inputs)
	if (locale === "it") return it_align_left_left_justify_left_pos(inputs)
	if (locale === "ru") return ru_align_left_left_justify_left_pos(inputs)
	if (locale === "es") return es_align_left_left_justify_left_pos(inputs)
	if (locale === "zh-CN") return zh_cn2_align_left_left_justify_left_pos(inputs)
	if (locale === "ja") return ja_align_left_left_justify_left_pos(inputs)
	if (locale === "hi") return hi_align_left_left_justify_left_pos(inputs)
	if (locale === "pt-PT") return pt_pt2_align_left_left_justify_left_pos(inputs)
	return en_align_left_left_justify_left_pos(inputs)
});